import { Routes } from '@angular/router';

import { urlEnvironmentGuard } from 'src/app/guards/url-environment.guard';

// All routes are lazy loaded to enable code splitting and keep the initial bundle small.
// The Dashboard (landing page) loads nearly instantly since it's the first navigation.
export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('src/app/pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
	},
	{
		path: 'analysis',
		loadComponent: () => import('src/app/pages/analysis-dashboard/analysis-dashboard.component').then(m => m.AnalysisDashboardComponent),
		canActivate: [urlEnvironmentGuard],
	},
	{
		path: 'ai-conversation/:conversationId',
		loadComponent: () => import('src/app/pages/ai-conversation/ai-conversation.component').then(m => m.AiConversationComponent),
		canActivate: [urlEnvironmentGuard],
	},
	{
		path: 'ai-conversation',
		loadComponent: () => import('src/app/pages/ai-conversation/ai-conversation.component').then(m => m.AiConversationComponent),
		canActivate: [urlEnvironmentGuard],
	},
	{
		path: 'search-results',
		loadComponent: () => import('src/app/components/search-results/search-results.component').then(m => m.SearchResultsComponent),
		canActivate: [urlEnvironmentGuard],
	},
	{
		path: 'suite-details/:uid',
		loadComponent: () => import('src/app/components/suite-details/suite-details.component').then(m => m.SuiteDetailsComponent),
		canActivate: [urlEnvironmentGuard],
	},
	{
		path: 'treo-suite-details/:uid',
		loadComponent: () => import('src/app/components/suite-details/environmentViews/treo/treo-suite-details.component').then(m => m.TreoSuiteDetailsComponent),
		canActivate: [urlEnvironmentGuard],
	},
	{
		path: 'results-suite-details/:uid',
		loadComponent: () => import('src/app/components/suite-details/environmentViews/results/results-suite-details.component').then(m => m.ResultsSuiteDetailsComponent),
		canActivate: [urlEnvironmentGuard],
	},
	{
		path: 'results-item-details/:uid',
		loadComponent: () => import('src/app/components/results-item-details/results-item-details.component').then(m => m.ResultsItemDetailsComponent),
	},
	{
		path: 'signal-visualizer',
		loadComponent: () => import('src/app/pages/signal-visualizer/signal-visualizer-page.component').then(m => m.SignalVisualizerPageComponent),
		data: { hideSidebar: true },
	},
	{
		path: 'settings',
		loadComponent: () => import('src/app/pages/settings/settings.component').then(m => m.SettingsComponent),
	},
	{
		path: '**',
		redirectTo: '',
	},
];
